import React, { useState } from "react";
import NewHead from "../../landing/NewHead";
import { Helmet } from "react-helmet";
import ServiceFooter from "../../ServiceFooter";
import "./uberclone.css";
import UberFeatureCard from "./UberFeatureCard";
import cardOne from "../../../image/uber/benefitcardone.webp";
import cardTwo from "../../../image/uber/benefitcardtwo.webp";
import cardThree from "../../../image/uber/benefitcardthree.webp";
import cardFour from "../../../image/uber/benefitcardfour.webp";
import cardFive from "../../../image/uber/benefitcardfive.webp";
import LOC from "../../../image/uber/customize-loc.svg";

import USERICON from "../../../image/uber/user-icon.webp";
import REALTIMEICON from "../../../image/uber/real-time-icon.webp";
import PAYMENTICON from "../../../image/uber/payment-icon.webp";

import { Navigation, A11y, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Link } from "react-router-dom";

const UberClone = () => {
  const [isPrevDisabled, setIsPrevDisabled] = useState(true);
  const [isNextDisabled, setIsNextDisabled] = useState(false);

  const [isPrevChooseDisabled, setIsPrevChooseDisabled] = useState(true);
  const [isNextChooseDisabled, setIsNextChooseDisabled] = useState(false);

  const handleSlideChange = (swiper) => {
    setIsPrevDisabled(swiper.isBeginning);
    setIsNextDisabled(swiper.isEnd);
  };

  const handleChooseChange = (chooseSwiper) => {
    setIsPrevChooseDisabled(chooseSwiper.isBeginning);
    setIsNextChooseDisabled(chooseSwiper.isEnd);
  };

  return (
    <>
      <NewHead />

      <Helmet>
        <title>Uber Clone Development</title>

        <meta name="title" content="Uber Clone Development" />
        <meta
          name="description"
          content="Launch your own ride-hailing service with a fully customizable Uber clone app. Our Uber clone offers advanced features and seamless scalability to grow your business."
        />

        <meta property="og:title" content="Uber Clone" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/uber-clone"
        />
      </Helmet>

      <div className="uber-main-wrap">
        {/* hero section */}
        <article className="uber-main">
          <div className="uber-hero">
            <div className="uber-container">
              <div className="row uber-hero-row">
                <div className="col-lg-6">
                  <div className="uber-hero-left">
                    <p className="uber-hero-left-content">
                      BUILD YOUR ON-DEMAND RIDE-SHARING APP
                    </p>
                    <h1>
                      Uber clone <span className="uber-hero-slash">|</span>{" "}
                      <br /> Uber clone app
                    </h1>
                    <p className="uber-hero-para">
                      launch a highly functional, fully customizable, and
                      cost-effective taxi booking platform without starting from
                      scratch using the Uber clone app, the game-changer for
                      your ride-hailing business.
                    </p>
                    <a
                      data-toggle="modal"
                      data-target="#myModal"
                      className="uber-btn"
                    >
                      Get Quote
                    </a>
                  </div>
                </div>
                <div className="col-lg-6 uber-hero-right-col">
                  <img
                    src={require("../../../image/uber/hero-right.webp")}
                    alt="Uber clone"
                  />
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* about section */}
        <article className="uber-about-wrap">
          <div className="uber-container">
            <div className="uber-about-outer-wrap m-0">
              <div className="uber-about-inner-wrap">
                <div className="row">
                  <div className="col-lg-7">
                    <div className="about-uber-clone-left">
                      <h6>What is an Uber Clone?</h6>
                      <p>
                        An Uber clone is a ready-made software solution that
                        mimics the core functionality of Uber, a popular
                        ride-hailing platform. With an Uber clone, businesses
                        can create their own taxi booking app that provides
                        users with convenient ride-hailing services, from
                        booking a ride to tracking drivers, payment processing,
                        and rating systems.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-5 ">
                    <div className="about-uber-clone-right">
                      <img
                        src={require("../../../image/uber/about-right.webp")}
                        alt="Uber clone"
                      />
                    </div>
                    <div className="about-uber-clone-right-mobile">
                      <img
                        src={require("../../../image/uber/about-right-mobile.webp")}
                        alt="Uber clone"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="about-top-card">
                <img
                  src={require("../../../image/uber/about-right-top.webp")}
                  alt="Uber clone"
                />
              </div>
            </div>
          </div>
          <div className="uber-container mt-5">
            <div className="uber-about-outer-wrap m-0">
              <div className="uber-about-inner-wrap">
                <div className="row about-uber-card-row">
                  <div className="col-lg-6 about-uber-left-img">
                    <div className="about-uber-clone-cardTwo">
                      <img
                        src={require("../../../image/uber/about-cardTwo.webp")}
                        alt="Uber clone"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 ">
                    <div className="about-uber-cardContent">
                      <h6>What is an Uber clone app?</h6>
                      <p>
                        The Uber clone app comes with pre-built features and
                        customization options that allow businesses to tailor
                        the app according to their unique needs. Whether you
                        want to focus on local taxi services, car rentals, or
                        ride-sharing services, the flexibility of an Uber clone
                        allows you to create a platform that meets specific
                        business goals.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* features */}
          <UberFeatureCard />
        </article>

        {/* How does */}
        <article className="uber-container">
          <div className="uber-work">
            <h6 className="uber-work-title">
              How does {""}
              <div className="content-inline">
                an <span className="primary-green"> Uber clone</span> work?
              </div>
            </h6>
          </div>

          <div className="uber-work-grid-wrap mt-4">
            <div className="uber-work-grid">
              <div className="user-reg-header">
                <h5 className="text-white">User Registration</h5>
                <div className="user-reg-arrow">
                  <i className="fa-solid fa-arrow-up-right-from-square"></i>

                  <img src={USERICON} alt="Uber clone" className="grid-icons" />
                </div>
              </div>
              <p className="user-reg-content">
                Users and drivers sign up for the platform through a simple
                registration process. Users can use their email,
                <span className="user-reg-dot">...</span>
                <span className="user-reg-span">
                  {" "}
                  phone number, or social media accounts to create an account,
                  while drivers undergo a more detailed process, including
                  license verification and vehicle information.
                </span>
              </p>
              <div className="text-center ">
                <img
                  src={require("../../../image/uber/work-grid-mobile.webp")}
                  alt="Uber clone"
                  className="user-reg-img"
                />
              </div>
            </div>
            <div className="uber-work-grid">
              <div className="ride-grid-wrapper">
                <p>
                  Once registered, users can search for rides by entering their
                  pickup and drop-off locations. The Uber clone app shows
                  available drivers nearby, and users can choose their preferred
                  option based on fare and estimated time of arrival.
                </p>
                <div className="user-reg-arrow bgclr-ride">
                  <i className="fa-solid fa-arrow-up-right-from-square"></i>
                  <img
                    src={REALTIMEICON}
                    alt="Uber clone"
                    className="grid-icons"
                  />
                </div>
              </div>
              <div className="ride-booking">
                <h5>Ride Booking</h5>
                <div>
                  <img
                    src={require("../../../image/uber/work-grid-ride.webp")}
                    alt="Uber clone"
                  />
                </div>
              </div>
            </div>
            <div className="uber-work-grid">
              <div className="real-time-top-title">
                <h5 className="text-white">Real-Time Tracking and Updates</h5>
                <p className="text-white">
                  After booking, users can track their driver’s real-time
                  location. They
                  <span className="real-dot">...</span>
                  <span className="user-reg-span">
                    {" "}
                    also receive notifications about the driver’s arrival, trip
                    details, and ride completion.
                  </span>
                </p>
              </div>
              <div className="real-time-bottom-title">
                <h5 className="text-white">Real-Time Tracking and Updates</h5>
              </div>
              <div className="user-reg-arrow bgclr-real-time">
                <i className="fa-solid fa-arrow-up-right-from-square"></i>
                <img
                  src={REALTIMEICON}
                  alt="Uber clone"
                  className="grid-icons"
                />
              </div>
            </div>
            <div className="uber-work-grid">
              <div className="payment-top-title">
                <h5>Payment and Rating</h5>
                <p>
                  At the end of the trip, users can choose from various
                  <span className="pay-dot">...</span>{" "}
                  <span className="user-reg-span">
                    payment options to settle the fare. Once payment is
                    complete, users can rate the driver and leave feedback.
                  </span>
                </p>
              </div>
              <div className="payment-bottom-title">
                <h5>Payment and Rating</h5>
              </div>
              <div className="user-reg-arrow bgclr-payment">
                <i className="fa-solid fa-arrow-up-right-from-square"></i>
                <img
                  src={PAYMENTICON}
                  alt="Uber clone"
                  className="grid-icons"
                />
              </div>
            </div>
          </div>
        </article>

        {/* benefits */}
        <article className="uber-benefits-wrap">
          <div className="uber-container">
            <div className="uber-slider">
              <h6 className="uber-work-title">
                Benefits of{" "}
                <div className="content-inline">
                  Uber Clone <span className="primary-green">for Business</span>
                </div>
              </h6>

              <div className="uber-slider-wrap">
                <Swiper
                  className="uber-swiper"
                  spaceBetween={30}
                  slidesPerView={4}
                  modules={[Navigation, A11y, Pagination]}
                  pagination={{
                    clickable: true,
                  }}
                  scrollbar={{ draggable: true }}
                  navigation={{
                    prevEl: ".uber-prev-arrow",
                    nextEl: ".uber-next-arrow",
                  }}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                    },
                    480: {
                      slidesPerView: 2,
                      spaceBetween: 20,
                    },
                    768: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },
                    1024: {
                      slidesPerView: 4,
                      spaceBetween: 40,
                    },
                  }}
                  onSlideChange={handleSlideChange}
                  onReachBeginning={() => setIsPrevDisabled(true)}
                  onReachEnd={() => setIsNextDisabled(true)}
                  onFromEdge={() => {
                    setIsPrevDisabled(false);
                    setIsNextDisabled(false);
                  }}
                >
                  <SwiperSlide>
                    <div className="uber-swiper-cards">
                      <img src={cardOne} alt="Uber clone" />
                      <h5>High Demand</h5>
                      <p>
                        The ride-hailing industry is booming, and there’s always
                        a demand for reliable and affordable services. By
                        launching an Uber clone app, you tap into a market with
                        millions of users looking for convenient transportation
                        solutions.
                      </p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="uber-swiper-cards">
                      <img src={cardTwo} alt="Uber clone" />
                      <h5>Brand Identity</h5>
                      <p>
                        An Uber clone allows you to build your brand from the
                        ground up. You have complete control over the app’s
                        design, functionality, and features, ensuring your
                        business stands out in a competitive market.
                      </p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="uber-swiper-cards">
                      <img src={cardThree} alt="Uber clone" />
                      <h5>Multiple Revenue Streams</h5>
                      <p>
                        An Uber clone offers several ways to generate revenue,
                        including ride commissions, subscription fees, and
                        advertisements. You can also introduce premium services
                        like luxury cars or carpooling to diversify your income.
                      </p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="uber-swiper-cards">
                      <img src={cardFour} alt="Uber clone" />
                      <h5>Global Reach</h5>
                      <p>
                        With the scalability of an Uber clone app, you can
                        easily expand your services to multiple locations. The
                        app’s multi-language and multi-currency support allow
                        you to reach a global audience without limitations.
                      </p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="uber-swiper-cards">
                      <img src={cardFive} alt="Uber clone" />
                      <h5>Real-Time Data Analytics</h5>
                      <p>
                        Understanding your customers and business performance is
                        crucial. The Uber clone includes advanced analytics
                        tools that provide valuable insights into user behavior,
                        driver performance, and overall app usage, helping you
                        make data-driven decisions.
                      </p>
                    </div>
                  </SwiperSlide>
                </Swiper>

                <button
                  className={`uber-prev-arrow ${
                    isPrevDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevDisabled ? "#fff" : "#fff",
                    cursor: isPrevDisabled ? "not-allowed" : "pointer",
                    background: isPrevDisabled ? "#D1D4D5" : "#171C1C",
                  }}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <button
                  className={`uber-next-arrow ${
                    isNextDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextDisabled ? "#fff" : "#fff",
                    cursor: isNextDisabled ? "not-allowed" : "pointer",
                    background: isNextDisabled ? "#D1D4D5" : "#171C1C",
                  }}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </article>

        {/* customization */}
        <article className="customize-container">
          <div className="customize-inner-wrap">
            <h6 className="text-center uber-work-title">
              <span className="primary-green">Customization</span>
              <br />
              Options for Uber Clone
            </h6>
            <p>
              When choosing an Uber clone app, you have the freedom to{" "}
              <div className="content-inline">
                customize it in various ways, including:
              </div>
            </p>

            <div className="customize-img-main">
              <div className="customize-img-grid-wrap">
                <div className="customize-img-grid">
                  <img src={LOC} alt="Uber clone" className="loc-one" />
                  <div className="bor-rad">
                    <div className="customize-inner-img-bg">
                      <div className="customize-blur-bg">
                        <div>
                          <h6>UI/UX Design</h6>
                          <p>
                            Modify the interface to reflect your brand’s style
                            and color scheme.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="customize-img-grid">
                  <img src={LOC} alt="Uber clone" className="loc-two" />
                  <div className="bor-rad">
                    <div className="customize-inner-img-bg map-img-two">
                      <div className="customize-blur-bg">
                        <div>
                          <h6>Features</h6>
                          <p>
                            Add or remove features like carpooling, luxury
                            services, or delivery options.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="customize-img-grid">
                  <img src={LOC} alt="Uber clone" className="loc-three" />
                  <div className="bor-rad">
                    <div className="customize-inner-img-bg map-img-three">
                      <div className="customize-blur-bg pay-blur">
                        <div>
                          <h6>Fiat and Crypto Payment gateway Integration</h6>
                          <p>
                            Incorporate local payment gateways and crypto
                            payment gateway to cater to specific regions.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="customize-img-grid">
                  <img src={LOC} alt="Uber clone" className="loc-four" />
                  <div className="bor-rad">
                    <div className="customize-inner-img-bg map-img-four">
                      <div className="customize-blur-bg">
                        <div>
                          <h6>Geo-Location</h6>
                          <p>
                            Tailor the app to operate in specific locations,
                            enabling regional language and currency support.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="customize-img-grid">
                  <img src={LOC} alt="Uber clone" className="loc-five" />
                  <div className="bor-rad">
                    <div className="customize-inner-img-bg map-img-five">
                      <div className="customize-blur-bg">
                        <div>
                          <h6>Security Enhancements</h6>
                          <p>
                            Strengthen the app’s security with additional
                            features like two-factor authentication or
                            encryption.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* business-modal */}
        <article className="uber-about-wrap">
          <div className="uber-container">
            <div className="business-outer-wrap m-0">
              <div className="uber-about-inner-wrap">
                <div className="row">
                  <div className="col-lg-5 col-xl-6">
                    <div className="business-modal-left">
                      <h4 className="business-model-left-title">
                        Uber Clone for Various{" "}
                        <div className="primary-green content-inline">
                          Business Models
                        </div>
                      </h4>
                      <img
                        src={require("../../../image/uber/business-model-phone.webp")}
                        alt="Uber clone"
                        className="business-model-img"
                      />
                    </div>
                  </div>
                  <div className="col-lg-7 col-xl-6">
                    <div className="business-model-right">
                      <p className="business-model-right-title">
                        The beauty of an Uber clone app is its versatility. You
                        can tailor the app to suit different business models,
                        including:
                      </p>
                      <div>
                        <div className="business-content-wrap">
                          <img
                            src={require("../../../image/uber/taxi.webp")}
                            alt="Uber clone"
                          />
                          <div>
                            <h6>Taxi Services</h6>
                            <p>
                              Offer a traditional taxi service with real-time
                              booking and GPS tracking.
                            </p>
                          </div>
                        </div>
                        <div className="business-content-wrap">
                          <img
                            src={require("../../../image/uber/car.webp")}
                            alt="Uber clone"
                          />
                          <div>
                            <h6>Car Rental Services</h6>
                            <p>
                              Provide car rentals by the hour or day, with
                              in-app booking and payment options.
                            </p>
                          </div>
                        </div>
                        <div className="business-content-wrap">
                          <img
                            src={require("../../../image/uber/delivery.webp")}
                            alt="Uber clone"
                          />
                          <div>
                            <h6>Delivery Services</h6>
                            <p>
                              Adapt your Uber clone for on-demand delivery of
                              goods and packages.
                            </p>
                          </div>
                        </div>
                        <div className="business-content-wrap">
                          <img
                            src={require("../../../image/uber/rideshare.webp")}
                            alt="Uber clone"
                          />
                          <div>
                            <h6>Ride-Sharing</h6>
                            <p>
                              Create a carpooling service to help reduce traffic
                              congestion and lower carbon emissions.
                            </p>
                          </div>
                        </div>
                        <div className="model-right-mobile">
                          <img
                            src={require("../../../image/uber/business-model-phone.webp")}
                            alt="Uber clone"
                            className="business-model-right-img"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="uber-why-choose-wrap">
              <p className="uber-why-subcontent">Why Choose an Uber Clone</p>
              <h3>
                For Your Taxi <br /> Booking Business?
              </h3>

              {/* why choose */}
              <div className="mt-2">
                <Swiper
                  className="uber-feature-swiper"
                  spaceBetween={30}
                  slidesPerView={4}
                  modules={[Navigation, A11y, Pagination]}
                  pagination={{
                    clickable: true,
                  }}
                  scrollbar={{ draggable: true }}
                  navigation={{
                    prevEl: ".uber-feature-prev-arrow",
                    nextEl: ".uber-feature-next-arrow",
                  }}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                    },
                    480: {
                      slidesPerView: 1,
                      spaceBetween: 20,
                    },
                    768: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                    },
                    1025: {
                      slidesPerView: 3,
                      spaceBetween: 40,
                    },
                    1200: {
                      slidesPerView: 4,
                      spaceBetween: 40,
                    },
                  }}
                  onSlideChange={handleChooseChange}
                  onReachBeginning={() => setIsPrevChooseDisabled(true)}
                  onReachEnd={() => setIsNextChooseDisabled(true)}
                  onFromEdge={() => {
                    setIsPrevChooseDisabled(false);
                    setIsNextChooseDisabled(false);
                  }}
                >
                  <SwiperSlide>
                    <div className="mt-5">
                      <div className="why-choose-card">
                        <h5>Cost-Effective Solution</h5>
                        <p>
                          Developing an Uber-like app from scratch can be
                          expensive. By opting for an Uber clone, you reduce
                          development costs significantly as it comes with all
                          the necessary features and functionalities.
                        </p>
                        <div className="feature-card-icon">
                          <img
                            src={require(`../../../image/uber/cost.webp`)}
                            alt="Uber clone"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="mt-5">
                      <div className="why-choose-card">
                        <h5>Quick Launch</h5>
                        <p>
                          Time is money, especially in the fast-moving world of
                          technology. An Uber clone app is a readymade solution
                          that enables you to quickly launch your business
                          without delays.
                        </p>
                        <div className="feature-card-icon">
                          <img
                            src={require(`../../../image/uber/quick.webp`)}
                            alt="Uber clone"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="mt-5">
                      <div className="why-choose-card">
                        <h5>Customization</h5>
                        <p>
                          The flexibility of an Uber clone is one of its most
                          attractive aspects. You can tailor the app to match
                          your business needs, from changing the colour scheme
                          to adding unique features like ride-sharing or
                          carpooling options.
                        </p>
                        <div className="feature-card-icon">
                          <img
                            src={require(`../../../image/uber/customization.webp`)}
                            alt="Uber clone"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="mt-5">
                      <div className="why-choose-card">
                        <h5>Scalable Solution</h5>
                        <p>
                          As your business grows, your Uber clone app can scale
                          accordingly. Whether you want to add more cities,
                          drivers, or advanced features, the app’s architecture
                          is designed to support future growth without requiring
                          a complete overhaul.
                        </p>
                        <div className="feature-card-icon">
                          <img
                            src={require(`../../../image/uber/scalable.webp`)}
                            alt="Uber clone"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="mt-5">
                      <div className="why-choose-card">
                        <h5>Advanced Technology</h5>
                        <p>
                          The Uber clone app uses the latest technologies,
                          including GPS integration, secure payment gateways,
                          and cloud storage, ensuring your platform remains
                          fast, reliable, and secure.
                        </p>
                        <div className="feature-card-icon">
                          <img
                            src={require(`../../../image/uber/advanced.webp`)}
                            alt="Uber clone"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>

                <button
                  className={`uber-feature-prev-arrow ${
                    isPrevChooseDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevChooseDisabled ? "#000" : "#000",
                    cursor: isPrevChooseDisabled ? "not-allowed" : "pointer",
                    background: isPrevChooseDisabled ? "#7B7E7F" : "#fff",
                  }}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <button
                  className={`uber-feature-next-arrow ${
                    isNextChooseDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextChooseDisabled ? "#000" : "#000",
                    cursor: isNextChooseDisabled ? "not-allowed" : "pointer",
                    background: isNextChooseDisabled ? "#7B7E7F" : "#fff",
                  }}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </article>

        {/* future */}
        <article className="uber-container">
          <div className="row uber-future">
            <div className="col-lg-6">
              <h5 className="uber-future-title">
                The Future of Ride -{" "}
                <div className="content-inline">Hailing with Uber Clone</div>
              </h5>
            </div>
            <div className="col-lg-6">
              <p className="uber-future-content">
                As technology evolves, so does the potential of the ride-hailing
                industry. With an Uber clone app, you are positioning your
                business to capitalize on future trends like electric vehicles
                (EVs), autonomous driving, and integrated mobility solutions.
                These innovations promise to make the ride-hailing experience
                even more efficient, eco-friendly, and convenient.
              </p>
            </div>
          </div>
          <div className="future-img-wrap">
            <img
              src={require("../../../image/uber/future-img.webp")}
              alt="Uber clone"
            />
          </div>
          <div className="uber-take-away">
            <div className="row">
              <div className="col-lg-6 uber-take-away-left-col">
                <h6 className="uber-take-away-title">Take Away</h6>
                <Link
                  data-toggle="modal"
                  data-target="#myModal"
                  className="uber-take-away-btn"
                >
                  Get Consultation
                </Link>
              </div>
              <div className="col-lg-6">
                <p className="uber-take-away-content">
                  An Uber clone offers a powerful and flexible solution for
                  entrepreneurs looking to launch a ride-hailing business. With
                  its advanced features, scalability, and customization options,
                  the Uber clone app can be the foundation of a highly
                  successful on-demand transportation platform. Whether you are
                  starting locally or aiming for global expansion, an Uber clone
                  can help you build a trusted and reliable brand in the
                  fast-growing ride-hailing market.
                </p>
              </div>
            </div>
          </div>
        </article>
      </div>

      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
                {/* <div className="landing-content-inline">
                  <span className="faq-span">Questions.</span>
                </div> */}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          What is an Uber clone?
                        </a>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          An Uber clone is a ready-made app solution that
                          replicates the functionalities of Uber, enabling you
                          to launch your own ride-hailing service.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          How much does it cost to develop an Uber clone app?
                        </a>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The cost of an Uber clone app varies based on
                          customization, features, and design requirements, but
                          it is generally more affordable than building from
                          scratch.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          Is the Uber clone app customizable?
                        </a>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, an Uber clone app is fully customizable, allowing
                          you to tailor the design and features to suit your
                          business needs.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq44"
                        >
                          How long does it take to launch an Uber clone app?
                        </a>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The launch time depends on the level of customization,
                          but most Uber clones can be deployed within a few
                          weeks.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead5">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq5"
                          aria-expanded="true"
                          aria-controls="faq5"
                        >
                          Can I scale the Uber clone app as my business grows?
                        </a>
                      </div>

                      <div
                        id="faq5"
                        className="collapse"
                        aria-labelledby="faqhead5"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, the Uber clone app is built for scalability,
                          allowing you to easily grow and expand your services
                          as your business evolves.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default UberClone;
